module.exports = __webpack_public_path__ + "static/img/IMG_0893.5d01c1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fotosGaleriaSicarf/IMG_0893.jpg
// module id = 6+cv
// module chunks = 11